import { axiosClient } from '@/libs/axios-client';

const BASE = '/team-assignments/billing';

// Answers 403 for whoever does not get the tab.
export const getBillingOptions = async () => {
  const { data } = await axiosClient.get(`${BASE}/options`);
  return data;
};

export const getBillingRequests = async (params) => {
  const { data } = await axiosClient.get(BASE, { params });
  return data;
};

export const exportBillingRequests = async (params) => {
  const { data } = await axiosClient.get(`${BASE}/export`, { params, responseType: 'blob' });
  return data;
};

export const saveBillingRequest = async ({ _id, ...payload }) => {
  const { data } = _id ? await axiosClient.put(`${BASE}/${_id}`, payload) : await axiosClient.post(BASE, payload);
  return data;
};

export const setBillingPrice = async ({ _id, ...payload }) => {
  const { data } = await axiosClient.post(`${BASE}/${_id}/price`, payload);
  return data;
};

export const setBillingResolved = async ({ _id, resolved }) => {
  const { data } = await axiosClient.post(`${BASE}/${_id}/resolve`, { resolved });
  return data;
};

export const setBillingStatus = async ({ _id, ...payload }) => {
  const { data } = await axiosClient.post(`${BASE}/${_id}/status`, payload);
  return data;
};
